/**
 * TODO: this menu will be deprecated in favor of mp-filter-menu, if adding
 * more functionality, please re-use and expand on that component
 */
import compact from 'lodash/compact';
import {Component} from 'panel';

import {filterAttributes} from 'common/util';
import {propagateEvent} from 'common/util/dom';
import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {PropertySectionItem} from 'common/query-builder/query-block/properties-menu/item-menu-types';
import {isProperty} from 'common/query-builder/query-block/properties-menu/types';

import {PropertyFilter} from './models/property-filter';
import {DisplayContext} from './models/types';
import {PropertyFilterFactory} from './models/utils';
import template from './index.jade';
import css from './index.inline.styl';
import './property-values-screen';

export interface PropertyFilterMenuState {
  propertyFilter: PropertyFilter;
}

export class PropertyFilterMenu extends Component<PropertyFilterMenuState> {
  private _tooltipPositionParentElement: HTMLElement;
  private _keydownProxyEl: HTMLElement;

  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'all-data-groups': {
        type: `boolean`,
        description: `whether to fetch/display props for all data groups; alternative to data-group-id attr.`,
      },
      'data-group-id': `string`,
      'display-context': {type: `string`, default: DisplayContext.Default},
      'enable-enhanced-list-filters': `boolean`,
      'event-name': `string`,
      'event-names': {type: `json`, default: null},
      'exclude-dimension-properties': `boolean`,
      'no-drop-menu': {type: `boolean`, description: `disable the drop menu`},
      'is-blocked-people': `boolean`,
      open: `boolean`,
      'prevent-close-selectors': `string`,
      'hide-events': `boolean`,
      'project-has-people': `boolean`,
      'project-id': `number`,
      'property-filter': `json`,
      'property-search-filter': `string`,
      'workspace-id': `number`,
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,

      defaultState: {
        propertyFilter: PropertyFilterFactory.createPropertyFilter(null, {displayContext: DisplayContext.Default}),
      },

      helpers: {
        filterAttributes,
        changeDropMenu: (ev) => this.dispatchEvent(new CustomEvent(`changeDropMenu`, ev)),
        changePropertyFilter: (ev) => propagateEvent(this, ev),
        clickBackFromPropertyValues: () => this.changePropertyFilter(this.createPropertyFilter(null)),
        commitPropertyFilter: (ev) => propagateEvent(this, ev),
        dispatchDraw: () => this.dispatchEvent(new CustomEvent(`draw`)),
        getEventNames: () => (this.eventNames ? JSON.stringify(this.eventNames) : null),
        getKeydownProxyEl: () => this.keydownProxyEl,
        getTooltipPositionParentElement: () => this.tooltipPositionParentElement,
        onPropertySelect: (ev) => this.onPropertySelect(ev.detail.item),
      },
    };
  }

  public connectedCallback() {
    super.connectedCallback();

    this.updatePropertyFilter(this.attr(`property-filter`));
  }

  public attributeChangedCallback(attr, oldVal, newVal) {
    super.attributeChangedCallback(attr, oldVal, newVal);

    switch (attr) {
      case `display-context`:
      case `all-data-groups`:
      case `event-name`:
      case `no-drop-menu`:
      case `open`:
      case `property-filter`:
        if (this.attr(`open`) || this.attr(`no-drop-menu`)) {
          this.updatePropertyFilter(this.attr(`property-filter`));
        }
        break;
      default:
        break;
    }
  }

  private onPropertySelect(property: PropertySectionItem) {
    const {resourceType, value} = property;
    let dataGroupId, tempDataGroupId, joinPropertyType, propertyDefaultType, type, scdEvent;
    if (isProperty(property)) {
      ({dataGroupId, tempDataGroupId, joinPropertyType, propertyDefaultType, type, scdEvent} = property);
    }
    const filter = this.createPropertyFilter({
      ...(dataGroupId ? {dataGroupId} : {}),
      ...(tempDataGroupId ? {tempDataGroupId} : {}),
      ...(joinPropertyType ? {joinPropertyType} : {}),
      ...(scdEvent ? {scdEvent} : {}),
      resourceType,
      propertyDefaultType,
      propertyName: value,
      propertyType: type,
    });

    this.changePropertyFilter(filter);
  }

  private updatePropertyFilter(attrs = null) {
    this.update({propertyFilter: this.createPropertyFilter(attrs)});
  }

  private createPropertyFilter(attrs) {
    return PropertyFilterFactory.createPropertyFilter(attrs, {displayContext: this.displayContext});
  }

  private changePropertyFilter(propertyFilter) {
    this.dispatchEvent(new CustomEvent(`changePropertyFilter`, {detail: {propertyFilter}}));
  }

  get displayContext() {
    return this.attr(`display-context`);
  }

  /**
   * Event names can be passed as a single event string in
   * $attrs[`event-name`] or as a list of events in $attrs[`event-names`]
   * TODO: consolidate consumers to pass it via `event-names`
   */
  get eventNames() {
    const eventNames = this.attr(`event-names`);
    const eventName = this.attr(`event-name`);

    return eventName ? compact([eventName]) : eventNames;
  }

  set tooltipPositionParentElement(el) {
    this._tooltipPositionParentElement = el;
    this.update();
  }

  get tooltipPositionParentElement() {
    return this._tooltipPositionParentElement;
  }

  set keydownProxyEl(el) {
    this._keydownProxyEl = el;
    this.update();
  }

  get keydownProxyEl() {
    return this._keydownProxyEl;
  }
}

export const PropertyFilterMenuEl = defineAndMakeJsxFactory(`mp-property-filter-menu`, PropertyFilterMenu);
export const PropertyFilterMenuReact = panel2react(`mp-property-filter-menu`, PropertyFilterMenu);
